const ROW_SELECTOR = '.custom-fields-row, .alternate-sku-field-row, .alternate-sku-generic-row';

const touchForm = (form) => form.dispatchEvent(new CustomEvent('form:touch'));

/** @param {HTMLButtonElement} button */
export const removeRow = (button) => {
    const form = button.form;

    button.closest(ROW_SELECTOR)?.remove();
    touchForm(form);
};

/** @param {HTMLButtonElement} button */
export const clearField = (button) => {
    const input = button.closest(ROW_SELECTOR)?.querySelector('input');

    if (!input) {
        return;
    }

    input.value = '';
    input.focus();
    touchForm(button.form);
};

/** @param {CustomEvent} event */
export const focusNewRow = (event) => {
    if (!event.detail?.requestConfig?.elt?.matches?.('[data-focus-new-row]')) {
        return;
    }

    event.detail.target?.lastElementChild?.querySelector('input')?.focus();
};
